/** Заказов в дневной пачке. */
export const DELIVERY_POOL_MAX_SIZE = 5;

/** @deprecated Пул обновляется по календарным дням, не по таймеру. */
export const DELIVERY_POOL_ROTATION_MS = 24 * 60 * 60 * 1000;

/** Начальное значение attemptsLeft в сохранении (лимит попыток не применяется). */
export const DELIVERY_ATTEMPTS_MAX = 3;

/** Стоимость повторного запуска (лётный пропуск). */
export const REPLAY_PASS_COST = 1;

export const PASSES_CAP = 1000;

/** Всего уровней (гигантов) в прогрессии. */
export const UNLOCKED_LEVELS_MAX = 9;

/** @deprecated Используйте {@link GIANT_UNLOCK_AVG_RATING}. */
export const RATING_PER_UNLOCK = 10;

/** Минимальный средний рейтинг для открытия гиганта по индексу (0 — всегда открыт). */
export const GIANT_UNLOCK_AVG_RATING: readonly number[] = [
  0, 0.5, 1.4, 2.2, 2.9, 3.4, 3.8, 4.1, 4.4, 4.6,
];

/** Идеальная доставка (100%). */
export const PERFECT_DELIVERY_RATING = 5;

/** Срочный заказ истекает через 6 часов после появления в пуле. */
export const URGENT_DELIVERY_TTL_MS = 6 * 60 * 60 * 1000;

/** @deprecated Используйте {@link passRewardForDelivery}. */
export const URGENT_DELIVERY_PASS_REWARD = 3;

/**
 * Награды улетными билетами за ежедневный вход (GDD v2: «Вход 7 дней подряд»).
 * День 1 → 1 билет, …, день 7 → 7 билетов.
 */
export const DAILY_LOGIN_PASS_REWARDS: readonly number[] = [1, 2, 3, 4, 5, 6, 7];

export function dailyLoginPassRewardForStreakDay(streakDay: number): number {
  const day = Math.max(1, Math.min(7, Math.floor(streakDay)));
  return DAILY_LOGIN_PASS_REWARDS[day - 1] ?? 1;
}

/** За включение уведомлений в игре (GDD v2). */
export const NOTIFICATIONS_PASS_REWARD = 3;

/** За бизнес-задания: подписка, приглашение друга и т.п. (GDD v2). */
export const BUSINESS_TASK_PASS_REWARD = 1;

/** Сколько вопросов квиза можно ответить за московские сутки. */
export const QUIZ_DAILY_LIMIT = 3;
